//@flow
import React from 'react';
import { Inline } from '../LayoutPrimitives';
import { PlaceholderText } from '../Placeholder';
import Breadcrumbs from '../Breadcrumbs';

type PropTypes = {
    path?: {}[],
    isLoading: boolean
}
const BreadcrumbsContainer = ({path, isLoading}: PropTypes) => {
    if(isLoading) {
        return (
            <Inline className="rec-breadcrumb-wrap">
                <PlaceholderText fontSize={20} lineHeight={23} width="150px" />
                <span> / </span>
                <PlaceholderText fontSize={20} lineHeight={23} width="150px" />
                <span> / </span>
                <PlaceholderText fontSize={20} lineHeight={23} width="150px" />
            </Inline>
        )
    }
    
    return (path && path.length > 0) && (
        <div className="rec-breadcrumb-wrap">
            <Breadcrumbs path={path} />
        </div>
    )
}

export default BreadcrumbsContainer;